export var FlowStep;
(function (FlowStep) {
    FlowStep["START"] = "start";
    FlowStep["SIGNUP"] = "signup";
    FlowStep["SIGNUP_PASSWORD"] = "signup/password";
    FlowStep["SIGNUP_SOCIAL"] = "signup/social";
    FlowStep["VERIFY_SOCIAL"] = "verify/social";
    FlowStep["VERIFY_PASSWORD"] = "verify/password";
    FlowStep["VERIFY_CAPTCHA"] = "verify/captcha";
    FlowStep["VERIFY_EMAIL"] = "verify/email";
    FlowStep["ENROLL_MFA_SELECT"] = "enroll/mfa/select";
    FlowStep["ENROLL_MFA_START"] = "enroll/mfa/start";
    FlowStep["ENROLL_MFA_COMPLETE"] = "enroll/mfa/complete";
    FlowStep["VERIFY_MFA_SELECT"] = "verify/mfa/select";
    FlowStep["VERIFY_MFA_START"] = "verify/mfa/start";
    FlowStep["VERIFY_MFA_COMPLETE"] = "verify/mfa/complete";
    FlowStep["VERIFY_RESET"] = "verify/password_reset";
    FlowStep["RESET_PASSWORD"] = "reset/password";
    FlowStep["MFA_SELECT"] = "mfa/select";
    FlowStep["VERIFY_EULA"] = "verify/eula";
    FlowStep["VERIFY_AGREEMENT"] = "verify/agreement";
    FlowStep["FLOW_GET"] = "get";
    FlowStep["COMPLETE"] = "complete";
    FlowStep["FLOW_RETURN"] = "return";
    FlowStep["INVALID_AUTH_METHOD"] = "invalid/auth";
    FlowStep["INVALID_STATE"] = "invalid/state";
})(FlowStep || (FlowStep = {}));
